import React, { Suspense,lazy, useState, useEffect,useContext } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { isLocalhost,API_BASE_URL } from "../checkLocalhost.jsx";


// utils/lazyWithWrapper.js
// import LazyWrapper from "../src/components/lazywrapper/LazyWrapper.jsx";

// export function lazyLoad(ComponentImport) {
//   const Component = lazy(ComponentImport);
//   return (props) => (
//     <LazyWrapper>
//       <Component {...props} />
//     </LazyWrapper>
//   );
// }




// initial pages
import Register from './routes/home/register/register';
import ForgotPassword from './routes/home/forgotpassword/forgotPassword';
import ResetPassword from './routes/home/resetassword/resetPassword';
import Login from './routes/home/login/login';
import HomePage from './routes/home/homePage/homePage';


// import ListPage from './routes/listPage/listPage';
// import DisplayProfilePage from './routes/displayProfile/DisplayProfilePage.jsx';
// import DisplayPostPage from './routes/displayPost/DisplayPostPage.jsx';

import TestCurvedMenu from "./routes/test/testCurvedMenu.jsx"
import TestShare from "./routes/test/TestShare.jsx";
import TestToast from "./routes/test/testToast.jsx";
import TestCardList from './routes/test/testCardList.jsx';


import { Layout, RequiredAdminAuth, RequiredAuth } from './routes/layout/layout';
import { AuthContext,AuthContextProvider } from "./context/AuthContext.jsx";


//lazy load pages


// import ProfilePage from './routes/dashboard/profilePage.jsx';
// import DashboardPage from './routes/dashboard/dashboard.jsx';
// import DashboardHome from './routes/dashboard/DashboardHome.jsx';
// import SavePostPage from './routes/savePosts/savePostPage.jsx';
// import InventoryPage from './routes/dashboard/InventoryList.jsx';
// import SavedListPage from './routes/dashboard/SavedListPage.jsx';
// import InboxPageList from './routes/dashboard/inboxPage.jsx';
// import ChatMessagePage from './routes/dashboard/chatMessagePage.jsx';

const SaveProfilePage =lazyLoad(()=>import("./routes/dashboard/SaveProfilePage.jsx"))
const DashboardPage = lazyLoad(() => import('./routes/dashboard/dashboard.jsx'))
const DashboardHome = lazyLoad(() => import('./routes/dashboard/DashboardHome.jsx'))
const SavePostPage =lazyLoad(()=>import('./routes/posts/savePostPage.jsx'))
const InventoryPage=lazyLoad(()=>import('./routes/posts/InventoryList.jsx'))
const SavedListPage=lazyLoad(()=>import('./routes/posts/SavedListPage.jsx'))
const InboxPageList=lazyLoad(()=>import('./routes/dashboard/inboxPage.jsx'))
const ChatMessagePage=lazyLoad(()=>import('./routes/dashboard/chatMessagePage.jsx'))


// admindashboard
// import AdminDashboardPage from './routes/admindashboard/AdminDashboard.jsx';
// import AdminDashboardHome from './routes/admindashboard/AdminDashbaordHome.jsx';
// import AdminDataPage from './routes/admindashboard/admindataPage.jsx';
// import ClientsListPage from './routes/admindashboard/ClientsListPage.jsx';
// import ClientPage from "./routes/admindashboard/ClientPage.jsx";
// import UsersPage from './routes/admindashboard/UsersPage.jsx';
// import MasterColonyList from "./routes/admindashboard/masters/MasterColonyList.jsx";
// import MasterColonySave from "./routes/admindashboard/masters/MasterColonySave.jsx";

const AdminDashboardPage =lazyLoad(()=>import('./routes/admindashboard/AdminDashboard.jsx'))
const AdminDashboardHome =lazyLoad(()=>import('./routes/admindashboard/AdminDashbaordHome.jsx'))
// const AdminDataPage=lazyLoad(()=>import('./routes/admindashboard/admindataPage.jsx'))

const AdminDataPage=lazyLoad(()=>import('./routes/admindashboard/AdminDataPage.jsx'))

const ClientsListPage=lazyLoad(()=>import('./routes/admindashboard/ClientsListPage.jsx'))
const ClientPage=lazyLoad(()=>import("./routes/admindashboard/ClientPage.jsx"))
const UsersPage=lazyLoad(()=>import('./routes/admindashboard/UsersPage.jsx'))
const MasterColonyList=lazyLoad(()=>import("./routes/admindashboard/masters/MasterColonyList.jsx"))
const MasterColonySave=lazyLoad(()=>import("./routes/admindashboard/masters/MasterColonySave.jsx"))




// subscriptions
// import DisplayBuildersDataPage from "./routes/dashboard/DisplayBuilderDataPage.jsx";
// import SubscriptionsPage from "./routes/dashboard/SubscriptionsPage.jsx";
// import Subdata from "./routes/dashboard/subscriptions/Subdata.jsx";
// import SubPosts from "./routes/dashboard/subscriptions/SubPosts.jsx";
// import Subadvertisements from "./routes/dashboard/subscriptions/Subadvertisements.jsx";
// import Subpayments from "./routes/dashboard/subscriptions/Subpayments.jsx";

const DisplayBuildersDataPage =lazyLoad(()=>import("./routes/dashboard/DisplayBuilderDataPage.jsx"))
const SubscriptionsPage=lazyLoad(()=>import("./routes/dashboard/SubscriptionsPage.jsx"))
const Subdata=lazyLoad(()=>import("./routes/dashboard/subscriptions/Subdata.jsx"))
const SubPosts=lazyLoad(()=>import("./routes/dashboard/subscriptions/SubPosts.jsx"))
const Subadvertisements=lazyLoad(()=>import("./routes/dashboard/subscriptions/Subadvertisements.jsx"))
const Subpayments=lazyLoad(()=>import("./routes/dashboard/subscriptions/Subpayments.jsx"))




// import SplashScreen from "./components/splashscreen/splashscreen.jsx";

import { 
  listPageLoader, 
  SaveProfilePageLoader, 
  displayPostPageLoader, 
  displayProfilePageLoader, 
  ClientsListPageLoader,
  ClientPageLoader,
  NullUsersLoader,
  MasterColoniesLocationLoader,
  ColonyPageLoader,
  BuilderDataPageLoader,
  getGatewayPayments
} from './lib/loaders';

import ClientContactList from "./routes/clients/ClientContactList.jsx";
import SaveContact from "./routes//clients/SaveClientContact.jsx";
import RequirementList from "./routes/dashboard/requirements/RequirementList.jsx";
import SaveRequirement from "./routes/dashboard/requirements/SaveRequirement.jsx";
import { lazyLoad } from "./lib/lazyLoad.jsx";
import Testpage from "./routes/test/testpage.jsx";
import MasterColonyPage from "./routes/admindashboard/masters/MasterColonyPage.jsx";
import MasterCitySave from "./routes/admindashboard/masters/MasterCitySave.jsx";
import ApartmentsPage from "./routes/admindashboard/masters/MasterApartmentsPage.jsx";

// import LazyWrapper from "./components/lazywrapper/LazyWrapper.jsx";
import DisplayProfilePage from './routes/profile/DisplayProfilePage';
import DisplayPostPage from './routes/posts/DisplayPostPage';
import ListPage from './routes/posts/listPage';
import ProjectListPage from './routes/projects/projectList';
import DisplayProjectPage from "./routes/projects/displayProject.jsx";
import SaveProject from "./routes/projects/saveProject.jsx";
import SelectedBasket from "./routes/basket/SelectedBasket.jsx";


function App() {
  // const [showSplash, setShowSplash] = useState(true);

useEffect(() => {
  console.log("App.jsx: App mounted");
}, []);


  const{currentUser}=useContext(AuthContext);

  // useEffect(() => {
  //   const timer = setTimeout(() => setShowSplash(false), 1300);
  //   return () => clearTimeout(timer);
  // }, []);


const PublicRoutes=[
  { path: "/", element: <HomePage /> },
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
  { path: "/forgotpassword", element: <ForgotPassword /> },
  { path: "/resetpassword", element: <ResetPassword /> },
  { path: "/list", element: <ListPage /> },
  { path: "/displayprofile/:id", element: <DisplayProfilePage />, loader: displayProfilePageLoader },
  { path: "/:id", element: <DisplayPostPage />, loader: displayPostPageLoader },
  { path: "/projects", element: <ProjectListPage /> },
  { path: "/projects/:id", element: <DisplayProjectPage /> },



];


const dashboardRoutes = [
  { index: true, element: <DashboardHome /> },
  // { path: "profile", element: <SaveProfilePage />, loader: SaveProfilePageLoader },
  { path: "profile", element: <SaveProfilePage />},
 
  { path: "inventory", element: <InventoryPage /> },
  { path: "savedlist", element: <SavedListPage /> },
  { path: 'savepost', element: <SavePostPage /> },
  { path: 'inbox', element: <InboxPageList /> },
  { path: 'contacts', element: <ClientContactList/> },
  { path: 'savecontact', element: <SaveContact/> },
  { path: 'requirements', element: <RequirementList/> },
  { path: 'saverequirement', element: <SaveRequirement/> },
  { path: 'saveproject', element: <SaveProject/> },
  { path: 'basket', element: <SelectedBasket /> },


  {path: 'data',element:<DisplayBuildersDataPage/>,loader:()=>BuilderDataPageLoader(currentUser?.id)},  
  {
    path: 'subscriptions',
    element: <SubscriptionsPage />, // Parent layout
    children: [
      { index: true, element: <Subdata /> }, // default
      { path: 'posts', element: <SubPosts /> },
      { path: 'ads', element: <Subadvertisements /> },
      { path: 'data', element: <Subdata /> },
      { path: 'payments', element: <Subpayments />,loader:()=>getGatewayPayments(currentUser?.id) },
    ]
  },
  { path: 'chat', element: <ChatMessagePage /> },
  // add other child routes here...
];

const adminRoutes = [
  { index: true, element: <AdminDashboardHome /> },
  { path: "clients",element: <ClientsListPage />,loader: ClientsListPageLoader},
  { path: "client/:id", element: <ClientPage />,loader: ClientPageLoader },
  { path: "users", element: <UsersPage />,loader: NullUsersLoader },
  { path: "data", element: <AdminDataPage /> },
  // { path: "colonies", element: <MasterColonyList />,loader: MasterColoniesLocationLoader },
    { path: "colonies", element: <MasterColonyPage/>},
    { path: "cities", element: <MasterCitySave/>},

  { path: "colony/:id", element: <MasterColonySave />,loader: ColonyPageLoader },
 { path: "apartments", element:<ApartmentsPage/> },
 

  
];



const TestRoutes=[
      { path: '/testcurve', element: <TestCurvedMenu/> },
      { path: '/testshare', element: <TestShare/> },
      { path: '/testtoast', element: <TestToast/> },
      { path: '/testcomp', element: <Testpage/> },

]

const router = createBrowserRouter(
  [
    { path: "/", element: <Layout />, children: PublicRoutes },
    { element: <RequiredAuth />, children: [{ path: "/dashboard", element: <DashboardPage />, children: dashboardRoutes }] },
    { element: <RequiredAdminAuth />, children: [{ path: "/admin", element: <AdminDashboardPage />, children: adminRoutes }] },
    ...TestRoutes,
    // { path: "/testcurve", element: <TestCurvedMenu /> },
    // { path: "/testshare", element: <TestShare /> },
    // { path: "/testtoast", element: <TestToast /> },
  ],
  { basename: isLocalhost ? "/" : "/" }
);




  return (
    <AuthContextProvider>
          <RouterProvider router={router} />
    </AuthContextProvider>
  );
}

export default App;
